/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyCompleteIcon = createIcon("EmptyCompleteIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M54 93c15.464 0 28-12.536 28-28S69.464 37 54 37 26 49.536 26 65s12.536 28 28 28Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 87c14.912 0 27-12.088 27-27S74.912 33 60 33 33 45.088 33 60s12.088 27 27 27Z",
    fill: "#fff",
    stroke: "#0C0D0D",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.38 66.379 15.936-15.937a1.5 1.5 0 012.122-.005l-.117-.117a1.494 1.494 0 01-.003 2.12L55.38 70.38l-7.941-7.942a1.497 1.497 0 010-2.117l-.118.117a1.505 1.505 0 012.122.005l5.937 5.937Z",
    fill: "#665AF4"
  }));
}, {
  "i18nKey": "svg.EmptyCompleteIcon"
});